<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />

    <!-- Profil User -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title class="headline">User Profile</v-card-title>

          <!-- Konten Kartu -->
          <v-card-subtitle>
            <v-row>
              <v-col class="text-center" cols="12" md="4">
                <v-avatar size="200">
                  <img
                    src="https://ceko.fli.co.id/assets/images/avatar-1.jpg"
                    alt="Profile Picture"
                    :key="employeeList.path_pohoto"
                  />
                </v-avatar>

                <v-btn small icon color="primary" @click="editDialog = true">
                  <!-- <v-icon>mdi-pencil</v-icon> -->
                </v-btn>
              </v-col>
              <v-col cols="12" md="8">
                <v-list>
                  <!-- Menampilkan nama -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Nama</v-list-item-title>
                      <v-list-item-subtitle>{{
                        employeeList.mst_employee_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Menampilkan username -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>NIK</v-list-item-title>
                      <v-list-item-subtitle>{{
                        employeeList.mst_employee_nik
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Menampilkan email -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Email</v-list-item-title>
                      <v-list-item-subtitle>{{
                        employeeList.mst_employee_email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Menampilkan role -->
                  <!-- Menampilkan email -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Position</v-list-item-title>
                      <v-list-item-subtitle>{{
                        employeeList.mst_position_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Menampilkan email -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Department</v-list-item-title>
                      <v-list-item-subtitle>{{
                        employeeList.mst_division_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-subtitle>

          <v-card-actions>
            <v-btn color="primary" @click="goToChangePassword">
              Change Password
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog Edit Foto -->
    <v-dialog v-model="editDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Edit Photo</v-card-title>
        <v-card-text>
          <!-- Input File -->
          <v-file-input
            label="Upload New Photo"
            accept="image/*"
            v-model="newPhoto"
            outlined
            @change="previewPhoto"
          ></v-file-input>

          <!-- Preview Foto -->
          <v-img
            v-if="previewPhotoUrl"
            :src="previewPhotoUrl"
            max-height="200"
            class="mt-3"
            aspect-ratio="1"
          ></v-img>
        </v-card-text>

        <v-card-actions>
          <v-btn text @click="closeEditDialog">Cancel</v-btn>
          <v-btn color="primary" :disabled="!newPhoto" @click="savePhoto">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      editDialog: false,
      newPhoto: null,
      previewPhotoUrl: null,
      urlPhotoProfile: null,
      employeeList: [],
    };
  },
  methods: {
    async fetchEmployeesById() {
      store.dispatch("showLoading");

      api
        .get(`/employees/${this.user.mst_employee_id}`)
        .then(({ data }) => {
          this.employeeList = data.data;
          // console.log(this.employeeList);
        })
        .catch((error) => {
          console.error("Error fetching employees:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    goToChangePassword() {
      this.$router.push({ name: "change-password" });
    },
    previewPhoto() {
      if (this.newPhoto) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewPhotoUrl = e.target.result;
        };
        reader.readAsDataURL(this.newPhoto);
      } else {
        this.previewPhotoUrl = null;
      }
    },
    async savePhoto() {
      if (!this.newPhoto) return;

      try {
        // Convert file menjadi Base64
        const reader = new FileReader();
        reader.onload = async () => {
          const base64Image = reader.result.split(",")[1]; // Mengambil string Base64 tanpa prefix "data:image/*;base64,"

          // Kirim Base64 ke server
          const response = await api.post(
            "/employees/upload-photo", // Ganti URL sesuai dengan endpoint Anda
            { image: base64Image }, // Kirimkan Base64 sebagai bagian dari payload
            {
              headers: { "Content-Type": "application/json" }, // Gunakan header JSON
            }
          );

          // Ambil pesan dari server
          const message = response.data.message || "Photo updated successfully";

          // Perbarui profil pengguna di Vuex
          store.commit("user/updateProfilePicture", response.data.filePath);

          // Reset form dan tampilkan notifikasi sukses
          this.closeEditDialog();
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        };

        reader.readAsDataURL(this.newPhoto); // Membaca file foto sebagai Base64
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update photo";
        store.dispatch("triggerSnackbar", {
          message: errorMessage,
          isSuccess: false,
        });
      }
    },
    closeEditDialog() {
      this.editDialog = false;
      this.newPhoto = null;
      this.previewPhotoUrl = null;
    },
  },
  mounted() {
    store.commit("setTitle", "Profile");
    this.fetchEmployeesById();
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
  },
};
</script>

<style scoped>
.v-img {
  border: 1px solid #ddd;
  border-radius: 8px;
}
</style>
